import React, {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate, useParams} from "react-router-dom";
import swal from "sweetalert";
import $ from "jquery";
import _ from "lodash";
import {useSelector} from "react-redux";
import '../../assets/css/pages/cart-item-users.css';
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";

export default function () {
  const {handleSubmit, control} = useForm();

  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  const {productId} = useParams();
  const token = useSelector(state => state.token);

  useEffect(() => {
    axios.get(`coupon-promotions/coupons`).then(res => {
      setData(res.data.data);
    });
  }, []);

  const sendCoupon = data => {
    data.users = bulkArray;
    axios.post('coupon-promotions/send-coupon', data).then(res => {
      if(res.data.status === 'success'){
        swal('Coupon code has sent successfully', {
          icon: "success",
        });
        navigate('/cart-items');
      }
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data?.errors || {});
      }
    });
  }

  useEffect(() => {
    $('#seller-applications thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#cart-item-users thead');

    let table = $('#cart-item-users').DataTable({
      "destroy": true,
      "ajax": {
        url: process.env.REACT_APP_API_URL + `coupon-promotions/${productId}/carts`,
        method: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw(false);

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'name', name: 'name'},
        {data: 'phone', name: 'phone'},
        {data: 'email', name: 'email'},
        {data: 'product_quantity', name: 'product_quantity'},
      ],
      "order": [[1, "desc"]],
    });

    table.off('click');

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

  }, []);

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const bulkSend = data => {
    swal({
      title: "Are you sure?",
      text: `You want to send coupons to selected users?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        sendCoupon(data)
      }
    });
  }

  return (
  <>
    <div>
      <div className="card card-flush py-4">
        <form onSubmit={handleSubmit(bulkSend)}>
          <div className="card-body">
            <ReactSelectInput
              label='Choose coupon'
              name='coupon_id'
              control={control}
              errorMessage={errors?.coupon_id}
              options={data?.coupons}
            />
          </div>
          <div className="card-footer d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-block btn-center btn-success"
              disabled={buttonIsDisabled}
            >
              <i className="far fa-trash-alt fs-5 mr-2"></i> Send coupon
            </button>
          </div>
        </form>
      </div>

      <table id="cart-item-users" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th></th>
          <th>Name</th>
          <th>Phone</th>
          <th>Email</th>
          <th>Quantity</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold"></tbody>
      </table>
    </div>
  </>
  );
}